import { ReactNode } from 'react';

const FilterInputLabel: React.FC<{ children: ReactNode }> = ({ children }) => (
  <p className='color-text mb-2.5 hidden text-sm md:flex'>{children}</p>
);

export default FilterInputLabel;
